import React from "react";
import styles from "./index.module.scss";
import CrowdTagMapping from "../CrowdTagMapping/TagMapping";
import TagMappingCrowd from "../TagMappingCrowd/TagMappingCrowd";

// 定义组件的 props 类型
interface CrowdGatheringProps {
  title?: string;
  desc?: string;
  list?: any[];
  changeCrowdListData: any;
  changeActiveListData: any;
}

// 创建基础组件 crowdGathering
const crowdGathering: React.FC<CrowdGatheringProps> = ({ title = "", desc = "", list, changeCrowdListData, changeActiveListData }) => {
  const [activeTagList, setActiveTagList] = React.useState<any[]>([]); //标签选择
  // 人群包列表
  const [crowdList, setCrowdList] = React.useState<any[]>([]);

  const [isDragOver, setIsDragOver] = React.useState(false); // 添加状态来跟踪是否正在拖拽

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(true); // 设置状态为正在拖拽
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    const data = event.dataTransfer.getData("application/json");
    const label = JSON.parse(data);
    // 如果存在id则为人群包
    if (label.id) {
      setCrowdList((prev) => [...prev, label]);
    } else {
      setActiveTagList((prev) => [...prev, processLabels(label)]);
    }
    // setActiveTagList((prev) => [...prev, processLabels(label)]);
    setIsDragOver(false); // 拖放后重置状态
  };

  const handleDragEnter = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    // setIsDragOver(true); // 设置状态为正在拖拽
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragOver(false); // 设置状态为未拖拽
  };

  //处理标准数据结构
  const processLabels = (i3: any) => ({
    id: i3?.label_id,
    labelName: i3?.label_name, // 年龄 == 八大人群
    labelDescription: i3?.label_name,
    label_desc: i3?.label_desc,
    labelType: i3?.label_type,
    valueType: i3?.label_type,
    opValue: i3.opValue,
    value: i3?.param_list?.map((i4: any) => ({
      ...i4,
      realValue: i4?.param_id,
      fieldValue: i4?.param_name,
      sub_param_list: i4.sub_param_list,
    })),
  });

  const changeActiveTagValue = (newData: any, contItem: any, contIndex: number) => {
    console.log("changeActiveTagValue", createTag(newData, contItem), contIndex);
    //  activeTagList的contIndex位置的value值替换为newData
    setActiveTagList((prev) =>
      prev.map((item, index) => {
        if (index === contIndex) {
          return { ...item, ...newData };
          // return createTag(newData, contItem);
        } else {
          return item;
        }
      })
    );
  };

  // 构建最终集合对象
  const createTag = (newData: any = {}, contItem: any) => {
    const data = {
      labelName: contItem.labelName,
      labelType: contItem.labelType,
      labelDescription: contItem.labelDescription,
    };
    return { ...data, ...newData };
  };

  const changeActiveList = (contItem: any, contIndex: number) => {
    setActiveTagList((prev) => prev.filter((_, index) => index !== contIndex));
  };

  const changeCrowdList = (contItem: any, contIndex: number) => {
    setCrowdList((prev) => prev.filter((_, index) => index !== contIndex));
  };

  // 拆分标签选择与人群包方法
  const splitTagAndCrowd = (list: any) => {
    const tagList: any = [];
    list?.forEach((i3: any) => {
      if (i3?.labelType != 8) {
        tagList.push(processLabels(i3));
      }
    });
    const crowdList = list?.filter((i3: any) => i3?.labelType == 8);
    setActiveTagList(tagList);
    setCrowdList(crowdList);
    changeActiveListData(tagList);
    changeCrowdListData(crowdList);
  };

  // 监听activeTagList数据
  React.useEffect(() => {
    changeActiveListData(activeTagList);
  }, [activeTagList]);

  // 监听crowdList数据
  React.useEffect(() => {
    changeCrowdListData(crowdList);
  }, [crowdList]);
  React.useEffect(() => {
    splitTagAndCrowd(list);
  }, [list]);

  return (
    <div className={`${styles["group-method"]}`}>
      <div className={`${styles.title}`}>
        <div>
          {title}-{desc}
        </div>
        <div className={`${styles.tagNum}`}>标签数量:{[...activeTagList,...crowdList].length}</div>
        {/* <div >展开</div> */}
      </div>
      <div className={`${styles["fixed-height"]} ${isDragOver ? styles["drag-over"] : ""}`} onDragOver={handleDragOver} onDrop={handleDrop} onDragEnter={handleDragEnter} onDragLeave={handleDragLeave}>
        <CrowdTagMapping activeTagList={activeTagList} changeActiveTagValue={changeActiveTagValue} changeActiveList={changeActiveList} />
        <TagMappingCrowd activeTagList={crowdList} changeActiveList={changeCrowdList} />
      </div>
    </div>
  );
};

export default crowdGathering;

